import React from "react";

import TopHeader from "./../Components/TopHeader/TopHeader";
import Menu from "./../Components/Header/Menu";
import Privcy from "./../Components/PrivacyPolicy/Privcy";
import Footer from "./../Components/Footer/Footer";

function PrivacyPolicy() {
  return (
    <>
      <TopHeader />
      <Menu />
      <Privcy />
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
